import authAxios from '@services/authAxios';

const fetchSisoStatistics = async (queries) => {
    const { data } = await authAxios({
        method: 'GET',
        url: `/api/v1/siso/statistics?${queries}`,
    });

    return data?.data;
};

export default fetchSisoStatistics;
